module.exports = __webpack_public_path__ + "static/media/symfony.81120281.svg";